import React, { Component } from "react";
import { connect } from "react-redux";
import Spinner from "../../../components/Spinner/Spinner";
import * as actions from "../../../store/actions/index";
import CompletedOrders from "../../../components/Bookings/completedOrders";
import OngoingOrders from "../../../components/Bookings/ongoingOrders";
import CancelledOrders from "../../../components/Bookings/cancelledOrders";
import WriteReviewModal from "../../../components/UI/Modal/writeReviewModal";
import SimpleGetRating from "../../../components/UI/Rating/SimpleRating";

class BookingTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onClickCompletedOrders = this.onClickCompletedOrders.bind(this);
    this.onClickCancelledOrders = this.onClickCancelledOrders.bind(this);
  }

  componentDidMount() {
    this.props.onFetchOngoingUserBookings(this.props.userId);
  }

  onClickCompletedOrders(e) {
    // e.preventDefault();
    this.props.resetLoadMoreBookings();
    this.props.onFetchCompletedUserBookings(this.props.userId);
  }

  onClickCancelledOrders(e) {
    this.props.onFetchCancelledUserBookings(this.props.userId);
  }

  render() {
    return (
      <section className="tabs content18 cid-sdv6gg2XCl" id="tabs1-o">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-9">
              <h3 className="mbr-section-title mt-5 mb-0 mbr-fonts-style display-2">
                My Bookings
              </h3>
            </div>
          </div>
          <div className="row justify-content-center mt-4">
            <div className="col-12 col-md-8">
              <ul className="nav nav-tabs mb4" id="myTab" role="tablist">
                <li className="nav-item">
                  <a
                    className="nav-link active mbr-fonts-style display-7"
                    id="ongoingOrders-tab"
                    data-toggle="tab"
                    href="#ongoingOrders"
                    role="tab"
                    aria-controls="ongoingOrders"
                    aria-selected="true"
                  >
                    <strong>Ongoing Order(s)</strong>
                  </a>
                </li>
                {/* <li className="nav-item">
                  <a
                    className="nav-link mbr-fonts-style display-7"
                    id="completedOrders-tab"
                    data-toggle="tab"
                    href="#completedOrders" 
                    role="tab"
                    aria-controls="completedOrders"
                    aria-selected="false"
                    onClick={this.onClickCompletedOrders}
                  >
                    <strong>Completed Order(s)</strong>
                  </a>
                </li> */}
                <li className="nav-item">
                  <a
                    className="nav-link mbr-fonts-style display-7"
                    id="cancelledOrders-tab"
                    data-toggle="tab"
                    href="#cancelledOrders"
                    role="tab"
                    aria-controls="cancelledOrders"
                    aria-selected="false"
                    onClick={this.onClickCancelledOrders}
                  >
                    <strong>Cancelled Order(s)</strong>
                  </a>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="ongoingOrders"
                  role="tabpanel"
                  aria-labelledby="ongoingOrders-tab"
                >
                  {this.props.ongoingBtnLoading ? (
                    <Spinner />
                  ) : (
                    <div className="row">
                      {this.props.ongoingOrders.map((ongoingOrders, index) => (
                        <OngoingOrders order={ongoingOrders} key={index} />
                      ))}
                      {!this.props.leadsexhausted ? (
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <button
                            className="btn btn-primary btn-sm"
                            id="loadMoreOngoingBookings"
                            onClick={() =>
                              this.props.LoadMoreCompletedOrders(
                                this.props.userId,
                                this.props.leadsexhausted,
                                this.props.lastDoc,
                                this.props.limit
                              )
                            }
                          >
                            Load More
                          </button>
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
                {/*                  
                <div
                  className="tab-pane fade"
                  id="completedOrders"
                  role="tabpanel"
                  aria-labelledby="completedOrders-tab"
                >
                  {this.props.completedBtnLoading ? (
                    <Spinner />
                  ) : (
                    <div className="row">
                      {this.props.completedOrders.map(
                        (completedOrders, index) => (
                          <CompletedOrders
                            order={completedOrders}
                            key={index + Math.random() * 10000}
                          />
                        )
                      )} 
                      {!this.props.leadsexhausted ? (
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() =>
                              this.props.LoadMoreCompletedOrders(
                                this.props.userId,
                                this.props.leadsexhausted,
                                this.props.lastDoc,
                                this.props.limit
                              )
                            }
                          >
                            Load More
                          </button>
                        </div>
                      ) : null}
                    </div>
                  )}
                </div> */}

                <div
                  className="tab-pane fade"
                  id="cancelledOrders"
                  role="tabpanel"
                  aria-labelledby="cancelledOrders-tab"
                >
                  {this.props.cancelBtnLoading ? (
                    <Spinner />
                  ) : (
                    <div className="row">
                      {this.props.cancelledOrders.map(
                        (cancelledOrders, index) => (
                          <CancelledOrders
                            order={cancelledOrders}
                            key={index}
                          />
                        )
                      )}
                      {!this.props.leadsexhausted ? (
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() =>
                              this.props.onLoadMoreCancelledOrders(
                                this.props.userId,
                                this.props.leadsexhausted,
                                this.props.lastDoc,
                                this.props.limit
                              )
                            }
                          >
                            Load More
                          </button>
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ongoingOrders: state.bookings.ongoingOrders,
    completedOrders: state.bookings.completedOrders,
    cancelledOrders: state.bookings.cancelledOrders,
    ongoingBtnLoading: state.bookings.ongoingBtnLoading,
    completedBtnLoading: state.bookings.completedBtnLoading,
    cancelBtnLoading: state.bookings.cancelBtnLoading,
    userId: state.auth.userId,
    leadsexhausted: state.bookings.leadsexhausted,
    limit: state.bookings.limit,
    lastDoc: state.bookings.lastDoc,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchOngoingUserBookings: (userId) =>
      dispatch(actions.onFetchOngoingUserBookings(userId)),
    onFetchCompletedUserBookings: (userId) =>
      dispatch(actions.onFetchCompletedUserBookings(userId)),
    onFetchCancelledUserBookings: (userId) =>
      dispatch(actions.onFetchCancelledUserBookings(userId)),
    LoadMoreCompletedOrders: (userId, leadsexhausted, lastDoc, limit) =>
      dispatch(
        actions.LoadMoreCompletedOrders(userId, leadsexhausted, lastDoc, limit)
      ),
    onLoadMoreCancelledOrders: (userId, leadsexhausted, lastDoc, limit) =>
      dispatch(
        actions.onLoadMoreCancelledOrders(
          userId,
          leadsexhausted,
          lastDoc,
          limit
        )
      ),
    resetLoadMoreBookings: () => dispatch(actions.resetLoadMoreBookings()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BookingTabs);
